import { useEffect, useContext } from 'react';
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';
import { useModal } from 'mui-modal-provider';

import { UnsavedChangesConfirmationModal } from '../unsaved-changes-confirmation-modal';
import { ILeavePrompt } from './leave-prompt.models';
import { useScreenState } from '../../../graphql/user/actions/screenBlock';
import { UnsavedChangesModal } from '../unsaved-changes-modal';

// TODO: temporary solution while react-router-dom doesn`t support Prompt
export const LeavePrompt = ({ confirmationModalProps }: ILeavePrompt): null => {
  const { setStateToBlocked, setStateToUnblock } = useScreenState();
  const { navigator } = useContext(NavigationContext) as any;
  const { showModal } = useModal();
  const UnsavedModal = confirmationModalProps ? UnsavedChangesConfirmationModal : UnsavedChangesModal;
  const unsavedProps = confirmationModalProps ? confirmationModalProps : [] as any;

  useEffect(() => {
    // Guard: block may be unavailable depending on router implementation
    if (!navigator || typeof navigator.block !== 'function') {
      return () => {
        setStateToUnblock();
      };
    }

    const unblock = navigator.block((tx: any) => {
      const { hide } = showModal(UnsavedModal as any, {
        ...unsavedProps,
        onConfirm: () => {
          unblock();
          setStateToUnblock();
          tx.retry();
          hide();
        },
        onReject: () => {
          hide();
        },
      });
    });

    setStateToBlocked(unblock);

    return () => {
      unblock();
      setStateToUnblock();
    };
  }, [navigator, UnsavedModal, showModal]);

  return null;
};
